<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { BlockContainer, SectionHeading, SectionHeadingShapeInt } from '@toni/brand-ui'

import { usePageStore } from '../../../stores/page'
import { useConfigStore } from '../../../stores/config'
import { usePageBlockWidth } from '../../../composables/use-page-block-width'
import TeaserGroup from '../../ui/teaser/TeaserGroup.vue'
import { useTeaserGroups } from '../../ui/teaser/use-teaser-groups'
import { useNativeTeasers } from '../../content-blocks/teaser/use-native-teasers'

const pageStore = usePageStore()

const props = defineProps<{
    id: string
  }>()

const id = computed(() => props.id)
const { t } = useI18n()

const { asideTeasers } = useTeaserGroups(id.value)

const headline = computed(() => useConfigStore().rsConfig.relatedArticlesHeadline || t('relatedArticles.headline'))

const brand = computed(() => pageStore.brandFromStore as string)
const isHome = computed(() => pageStore.isHome as boolean)
const size = computed(() => usePageBlockWidth(pageStore.pageData?.pageMeta, isHome.value, brand.value).value)

const nativeTeaserOptions = computed(() => ({
  currentContentBlockId: id.value,
  teasers: asideTeasers.value
}))
const teasersWithNativeTeasers = useNativeTeasers(nativeTeaserOptions.value)
</script>

<template>
  <BlockContainer
    v-if="asideTeasers.length > 0"
    :size="size"
    :data-ems="'ems-related-articles'"
    :flex-container="false"
    class="mb-6 md:mb-8">
    <div class="flex flex-col mb-5 sm:mb-6 lg:mb-8">
      <div class="flex flex-row items-center space-x-2 sm:space-x-2.5 md:space-x-3 lg:space-x-3.5">
        <SectionHeadingShapeInt variant="tertiary" />
        <SectionHeading :uppercase="false"
                        class="text-heading-display-xxs sm:text-heading-display-xs md:text-heading-display-xs lg:text-heading-display-sm">
          {{ headline }}
        </SectionHeading>
      </div>
    </div>

    <TeaserGroup
      :teasers="teasersWithNativeTeasers"
      variant="teaser-group-quadruple" />
  </BlockContainer>
</template>
